<template>
  <v-dialog
    v-model="confirmBox"
    :fullscreen="mobileScreen"
    max-width="500"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs12>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="confirmBox = false"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <p class="text-xs-left f-16 sz_grafit--text ma-0 mt-1">
            {{ removeTitle }}
          </p>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-end="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1"
            :class="[mobileScreen ? 'mt-2' : 'mr-3']"
          >
            <v-btn
              flat
              color="sz_violet"
              class="text-none"
              @click="confirmBox = false"
            >
              {{ $t('buttons.cancel') }}
            </v-btn>
          </v-flex>
          <v-spacer />
          <v-flex
            order-xs1
            order-sm2
          >
            <v-btn
              color="sz_violet"
              @click="$emit('response-ok')"
            >
              {{ $t('buttons.delete') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmDialog',
    props: {
        visible: {
            default: false,
            type: Boolean
        },
        title: {
            default: null
        }
    },
    data () {
        return {
            confirmBox: false
        };
    },
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        removeTitle () {
            return this.title ? this.title : this.$t('message.confirm_remove');
        }
    },
    watch: {
        visible (val) {
            this.confirmBox = val;
        },
        confirmBox (val) {
            this.$emit('dialog', val);
        }
    }
};
</script>

<style scoped></style>
